import { Injectable, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from './../modal/modal.component';

@Injectable({
	  providedIn: 'root'
	})
export class DynamicComponentLoaderService {
  constructor(/*private dialog: MatDialog, */
		  private router: Router, private route: ActivatedRoute, private viewContainerRef: ViewContainerRef
) {
  }
  loadFromRoute(viewContainerRef: ViewContainerRef, routePath: string): any{
	  

	  const componentType = this.router.config.find(route => (route.path == routePath)||(([route.path][0] != '/')&&('/'+ route.path == routePath)))?.component;
	  console.log(componentType);	
	  if (componentType) {
		  return  this.loadComponent(viewContainerRef, componentType);
	  }
  }
  loadComponent(viewContainerRef: ViewContainerRef, component: any) {
   const componentRef = viewContainerRef.createComponent(component);
   return componentRef.instance;
  }
  
  

}